<div class="profile-bg-section">
    <div class="profile-section">
        <div class="profile-heading-section">
            <span>Know Your Advisor</span>
            <span class="profile-close-icon" (click)="close()">&times;</span>
        </div>
        <div class="profile-content-section">
            <ng-container *ngIf="profile_data_loaded">
                <div class="profile-basic-info-section">
                    <div>
                        <div class="profile-image-section">
                            <img [src]="base_url + profile_data.profile_pic" onerror="this.src='assets/user-profile.png'" class="profile-image" />
                        </div>
                        <div class="profile-meta-data-section">
                            <p class="profile-name">{{profile_data.first_name}} {{profile_data.last_name}}</p>
                            <div class="profile-status-section">
                                <span class="profile-status-active-tag" *ngIf="profile_data.advisor_status == 'Active'">Active</span>
                                <span class="profile-status-inactive-tag" *ngIf="profile_data.advisor_status != 'Active'">In-Active</span>
                            </div>
                            <div class="profile-social-section">
                                <img src="assets/ic-linkedin.png" class="each-profile-social-image" (click)="navigateToExternalLink(profile_data.linkedin_url)" />
                                <img src="assets/ic-twitter.png" class="each-profile-social-image" (click)="navigateToExternalLink(profile_data.twitter_url)" />
                                <img src="assets/ic-facebook.png" class="each-profile-social-image" (click)="navigateToExternalLink(profile_data.facebook_url)" />
                            </div>
                            <span class="profile-member-section">Advisor Since: {{profile_data.date_of_joining | date: "dd MMM yyyy"}}</span>
                        </div>
                    </div>
                    <div class="profile-recommendation-section">
                        <div class="each-profile-recommendation-section">
                            <span class="each-profile-recommendation-label">Coaching Plan Assigned</span>
                            <span class="each-profile-recommendation-yes" *ngIf="profile_data.coaching_plan_assigned">Yes</span>
                            <span class="each-profile-recommendation-no" *ngIf="!profile_data.coaching_plan_assigned">No</span>
                        </div>
                        <div class="each-profile-recommendation-section">
                            <span class="each-profile-recommendation-label">Risk</span>
                            <span class="each-profile-recommendation-yes" *ngIf="profile_data.advisor_attrition">Yes</span>
                            <span class="each-profile-recommendation-no" *ngIf="!profile_data.advisor_attrition">No</span>
                        </div>
                    </div>
                </div>
                <div class="profile-tabs-section">
                    <div class="each-profile-tab" *ngFor="let profile_tab of profile_tabs" [ngClass]="{'each-profile-tab-selcted': profile_tab_selected == profile_tab.name}" (click)="changeTab(profile_tab)">
                        <span>{{profile_tab.name}}</span>
                    </div>
                </div>
                <ng-container *ngIf="profile_tab_selected == profile_tabs[0].name">
                    <div class="profile-details-section " *ngFor="let profile_section of profile_fields_data">
                        <div class="profile-details-heading-section ">
                            <span>{{profile_section.name}}</span>
                        </div>
                        <div class="profile-details-content-section ">
                            <div class="each-profile-details-section" *ngFor="let profile_field of profile_section.fields">
                                <p class="each-profile-details-label">{{profile_field.name}}</p>
                                <p class="each-profile-details-value">{{getValue(profile_field, profile_field.key)}}</p>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="profile_tab_selected == profile_tabs[1].name">
                    <div class="profile-products-section ">
                        <div class="each-profile-product-section each-profile-product-active">
                            <div class="each-profile-product-heading-section">
                                <span>{{profile_data.designation}}</span>
                                <span class="each-profile-product-inactive-tag each-profile-product-active-tag">CURRENT</span>
                            </div>
                            <div class="each-profile-product-details-section">
                                <div class="each-profile-product-aum-section">
                                    <p class="each-profile-product-aum-label">Employment ID</p>
                                    <p class="each-profile-product-aum-value" *ngIf="profile_data.employment_id != '' && profile_data.employment_id != null">{{profile_data.employment_id}}</p>
                                    <p class="each-profile-product-aum-value" *ngIf="profile_data.employment_id == '' || profile_data.employment_id == null">-</p>
                                </div>
                                <div class="each-product-detail-section">
                                    <span class="each-product-detail-label">Employment Type</span>
                                    <span class="each-product-detail-value">{{profile_data.employment_type}}</span>
                                </div>
                                <div class="each-product-detail-section">
                                    <span class="each-product-detail-label">Date of Joining</span>
                                    <span class="each-product-detail-value">{{profile_data.date_of_joining | date: "dd MMM yyyy"}}</span>
                                </div>
                                <div class="each-product-detail-section">
                                    <span class="each-product-detail-label">Company Name</span>
                                    <span class="each-product-detail-value">{{profile_data.financial_institution.institution_name}}</span>
                                </div>
                                <div class="each-product-detail-section">
                                    <span class="each-product-detail-label">Company Registration Type</span>
                                    <span class="each-product-detail-value">{{profile_data.financial_institution.institution_registration_type_name}}</span>
                                </div>
                                <div class="each-product-detail-section">
                                    <span class="each-product-detail-label">Branch ID</span>
                                    <span class="each-product-detail-value">{{profile_data.financial_institution_branch_details.branch_id}}</span>
                                </div>
                                <div class="each-product-detail-section">
                                    <span class="each-product-detail-label">Branch Name</span>
                                    <span class="each-product-detail-value">{{profile_data.financial_institution_branch_details.name}}</span>
                                </div>
                                <div class="each-product-detail-section">
                                    <span class="each-product-detail-label">Address</span>
                                    <span class="each-product-detail-value">{{profile_data.financial_institution_branch_details.address}}</span>
                                </div>
                                <div class="each-product-detail-section">
                                    <span class="each-product-detail-label">City</span>
                                    <span class="each-product-detail-value">{{profile_data.financial_institution_branch_details.city}}</span>
                                </div>
                                <div class="each-product-detail-section">
                                    <span class="each-product-detail-label">State</span>
                                    <span class="each-product-detail-value">{{profile_data.financial_institution_branch_details.state_name}}</span>
                                </div>
                                <div class="each-product-detail-section">
                                    <span class="each-product-detail-label">Zip Code</span>
                                    <span class="each-product-detail-value">{{profile_data.financial_institution_branch_details.zipcode}}</span>
                                </div>
                            </div>
                            <div class="each-profile-product-sub-details-section">
                                <div class="each-product-detail-section">
                                    <span class="each-product-detail-label">Phone Number</span>
                                    <span class="each-product-detail-value">{{profile_data.financial_institution_branch_details.phone_number}}</span>
                                </div>
                                <div class="each-product-detail-section">
                                    <span class="each-product-detail-label">Email</span>
                                    <span class="each-product-detail-value">{{profile_data.financial_institution_branch_details.email}}</span>
                                </div>
                                <div class="each-product-detail-section">
                                    <span class="each-product-detail-label">Product Experience</span>
                                    <!-- <span class="client-profile-value">{{profile_data.product_experience_list.length}}</span> -->
                                    <span class="each-product-detail-value">{{profile_data.product_experience_list.length}}</span>
                                    <!-- <span class="client-profile-value" *ngFor="let product of profile_data.product_experience_list; let index = index"> -->
                                    <span class="each-product-detail-value" *ngFor="let product of profile_data.product_experience_list; let index = index">
                                        <span *ngIf="index == 0">(</span>
                                        {{ product.name }}
                                        <span *ngIf="index + 1 != profile_data.product_experience_list.length">, </span>
                                        <span  *ngIf="index + 1 == profile_data.product_experience_list.length">)</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="each-profile-product-section each-profile-product-inactive" *ngFor="let experience of profile_data.employment_details">
                            <div class="each-profile-product-heading-section">
                                <span>{{experience.company_name}}</span>
                                <span class="each-profile-product-inactive-tag">PAST</span>
                            </div>
                            <div class="each-profile-product-details-section">
                                <div class="each-profile-product-aum-section">
                                    <p class="each-profile-product-aum-label">Employment ID</p>
                                    <p class="each-profile-product-aum-value">{{experience.prior_employment_id}}</p>
                                </div>
                                <div class="each-product-detail-section">
                                    <span class="each-product-detail-label">Date of Joining</span>
                                    <span class="each-product-detail-value">{{experience.start_date | date: "dd MMM yyyy"}}</span>
                                </div>
                                <div class="each-product-detail-section">
                                    <span class="each-product-detail-label">Date of Leaving</span>
                                    <span class="each-product-detail-value">{{experience.end_date | date: "dd MMM yyyy"}}</span>
                                </div>
                                <div class="each-product-detail-section">
                                    <span class="each-product-detail-label">Total Work Experience</span>
                                    <span class="each-product-detail-value">
                                        {{ experience.work_years }} Year
                                        <span *ngIf="experience.work_years != 1">s</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="profile_tab_selected == profile_tabs[2].name">
                    <div class="profile-products-section" *ngIf="profile_data.services.length > 0">
                        <ng-container *ngFor="let service of profile_data.services">
                            <div class="each-service-section">
                                <p class="each-service-name">{{ service.name }}</p>
                                <p class="each-service-subscription">{{ service.type }}: {{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ service.cost }}/{{ service.duration }}</p>
                                <p class="each-service-description">{{ service.description }}</p>
                                <div class="each-service-tags-section">
                                    <span class="each-service-tag" *ngFor="let offer of service.services_offered_list">{{ offer.name }}</span>
                                </div>
                            </div>
                          </ng-container>
                    </div>
                    <ng-container *ngIf="profile_data.services.length == 0">
                        <div class="each-product-zero-section">
                            <span class="each-profile-product-aum-value">No Services Found</span>
                        </div>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="profile_tab_selected == profile_tabs[3].name">
                    <app-advisor-profile-sales-history [advisor_data_id]="profile_data.id"></app-advisor-profile-sales-history>
                </ng-container>
                <ng-container *ngIf="profile_tab_selected == profile_tabs[4].name">
                    <app-view-coaching-plans [advisor_id]="profile_data.id" [action_type]="'View'"></app-view-coaching-plans>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="!profile_data_loaded">
                <app-loader [loading_text]="'Loading Advisor Data'"></app-loader>
            </ng-container>
        </div>
    </div>
</div>
